import { ButtonPrimary } from 'app/components';
import {
  StyledCtContainer,
  StyledSubtitle,
  StyledTitle,
} from '../ConsignedStep.styles';

type AuthorizationSendedProps = {
  backStep: () => void;
};
const AuthorizationSended = ({ backStep }: AuthorizationSendedProps) => {
  return (
    <>
      <StyledCtContainer>
        <br />
        <StyledTitle>Termo de aceite enviado!</StyledTitle>
        <StyledSubtitle>Aguardando o tomador aceitar o termo.</StyledSubtitle>
      </StyledCtContainer>
      <ButtonPrimary
        typeVariant="outline"
        onClick={backStep}
        style={{ width: '15rem', marginTop: '2rem' }}
      >
        Reenviar termo de aceite
      </ButtonPrimary>
    </>
  );
};

export default AuthorizationSended;
